export enum PackageDeliveryType {
    PLANE,
    SHIP,
    SEMI_EXPRESS,
    EXPRESS
}